import styled, { keyframes } from 'styled-components';
import { MINT_MIST } from '../../../constants/brandSurfaces';

const blue = '#0d4efe';
const ink = '#1a1a2e';

const tickerScroll = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
`;

export const TickerRegion = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: ${MINT_MIST};
  color: ${ink};
  border-bottom: 1px solid rgba(26, 26, 46, 0.08);
  height: 36px;

  &:hover .site-ticker-track,
  &:focus-within .site-ticker-track {
    animation-play-state: paused;
  }

  @media (prefers-reduced-motion: reduce) {
    height: auto;
    overflow: visible;
  }
`;

export const TickerTrack = styled.div`
  display: flex;
  width: max-content;
  height: 100%;
  align-items: center;
  animation: ${tickerScroll} ${({ $duration }) => $duration}s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    width: 100%;
    height: auto;
    flex-wrap: wrap;
  }
`;

export const TickerSequence = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 1.75rem;
  padding-right: 1.75rem;
  height: 100%;

  &[data-copy='duplicate'] {
    @media (prefers-reduced-motion: reduce) {
      display: none;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding: 8px 16px 10px;
    row-gap: 6px;
  }
`;

export const LeadIn = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${blue};
  white-space: nowrap;
`;

export const SeparatorMark = styled.img`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: block;
  object-fit: contain;
  pointer-events: none;
`;

export const HighlightLink = styled.a`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${ink};
  text-decoration: none;
  white-space: nowrap;
  border-radius: 6px;
  padding: 2px 6px;

  &:hover,
  &:focus-visible {
    color: ${blue};
    background: rgba(13, 78, 254, 0.05);
    text-decoration: none;
  }

  &:focus-visible {
    outline: 2px solid ${blue};
    outline-offset: 2px;
  }
`;
